module.exports = __webpack_public_path__ + "img/finish (1).fbbd361b.svg";